import { Pipe, PipeTransform } from '@angular/core';
import { Fce } from '../fce';

@Pipe({ name: 'cropText' })
export class CropTextPipe implements PipeTransform {
    constructor() { }

    transform(text: string, max = 20): string {
        return text ? Fce.cropText(text, max) : ''
    }
} 
